import GeofleetPublicChatWidget from './chat-widget/GeofleetPublicChatWidget';

const publicChatEnabled = import.meta.env.VITE_GEOFLEET_PUBLIC_CHAT !== '0';

/**
 * Geofleet on-site assistant (public chat API). Intercom has been removed in favor of this widget.
 */
export default function Chatbot() {
  return publicChatEnabled ? <GeofleetPublicChatWidget /> : null;
}
